class WishlistBtn extends HTMLElement {
  handle; full; empty;
  static selectors = {
    full: '.wishlist-yes',
    empty: '.wishlist-no',
  }
  static classes = {
    inactive: 'd-none'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.handle = this.dataset.handle;
    this.full = this.querySelector(WishlistBtn.selectors.full);
    this.empty = this.querySelector(WishlistBtn.selectors.empty);
    this.checkStatus();

    this.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleWishlist();
    });
  }

  toggleWishlist = () => {
    if(this.isWishlist()){
      this.removeFromWishlist();
    } else {
      this.addToWishlist();
    }
  }

  addToWishlist = () => {
    const wishlist = Utils.getWishlist();
    wishlist.unshift(this.handle);
    localStorage.setItem(Utils.WISHLIST, wishlist.join(','));
    this.checkStatus();
    window.dispatchEvent(new CustomEvent(Utils.WISHLIST_ADDED, { detail: this.handle }));
  }

  removeFromWishlist = () => {
    const wishlist = Utils.getWishlist();
    var index = wishlist.indexOf(this.handle);
    if (index > -1) {
      wishlist.splice(index, 1);
    }
    localStorage.setItem(Utils.WISHLIST, wishlist.join(','));
    window.dispatchEvent(new CustomEvent(Utils.WISHLIST_REMOVED, { detail: this.handle }));
    this.checkStatus();
  }

  checkStatus = () => {
    if(this.isWishlist()){
      this.full.classList.remove(WishlistBtn.classes.inactive);
      this.empty.classList.add(WishlistBtn.classes.inactive);
    } else {
      this.empty.classList.remove(WishlistBtn.classes.inactive);
      this.full.classList.add(WishlistBtn.classes.inactive);
    }
  }
 
  isWishlist = () => { 
    var found = false;
    const wishlist = Utils.getWishlist();
    wishlist.forEach((item) => {
      if(item.localeCompare(this.handle) == 0){
        found = true;
        return;
      }
    });
    return found;
  }
  
}
if (!window.customElements.get("wishlist-btn")) {
  window.customElements.define("wishlist-btn", WishlistBtn);
}